import { ChakraProvider, Portal, useDisclosure } from '@chakra-ui/react';
import React, { useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import routes from 'routes/routes';
import theme from 'theme/theme.js';

// Components (reuse same ones)
import AdminNavbar from 'components/Navbars/AdminNavbar.js';
import Sidebar from 'components/Sidebar';
import FixedPlugin from 'components/FixedPlugin/FixedPlugin';
import Configurator from 'components/Configurator/Configurator';

import MainPanel from 'components/Layout/MainPanel';
import PanelContainer from 'components/Layout/PanelContainer';
import PanelContent from 'components/Layout/PanelContent';

export default function MerchantLayout(props) {
  const { ...rest } = props;

  const [sidebarVariant, setSidebarVariant] = useState('transparent');
  const [fixed, setFixed] = useState(false);
  const filteredRoutes = routes.filter(r => r.layout === "/merchant");
  const getRoute = () => {
    return true;
  };


  const getActiveRoute = (routes) => {
    let activeRoute = 'Merchant Panel';

    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) return collapseActiveRoute;
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoute(routes[i].views);
        if (categoryActiveRoute !== activeRoute) return categoryActiveRoute;
      } else {
        if (
          window.location.href.indexOf(
            routes[i].layout + routes[i].path
          ) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };

  const getActiveNavbar = (routes) => {
    let activeNavbar = false;

    for (let i = 0; i < routes.length; i++) {
      if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbar(routes[i].views);
        if (categoryActiveNavbar !== activeNavbar) return categoryActiveNavbar;
      } else {
        if (
          window.location.href.indexOf(
            routes[i].layout + routes[i].path
          ) !== -1
        ) {
          if (routes[i].secondaryNavbar) return routes[i].secondaryNavbar;
        }
      }
    }
    return activeNavbar;
  };


  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) return getRoutes(prop.views);
      if (prop.category === 'account') return getRoutes(prop.views);

      if (prop.layout === '/merchant') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const { isOpen, onOpen, onClose } = useDisclosure();

  document.documentElement.dir = 'ltr';

  return (
    <ChakraProvider theme={theme} resetCss={false}>
      <Sidebar
        routes={filteredRoutes}
        logoText={'MOGOMA MERCHANT'}
        sidebarVariant={sidebarVariant}
        {...rest}
      />

      <MainPanel
        w={{
          base: '100%',
          xl: 'calc(100% - 275px)',
        }}
      >
        <Portal>
          <AdminNavbar
            onOpen={onOpen}
            logoText={'MOGOMA MERCHANT'}
            brandText={getActiveRoute(routes)}
            secondary={getActiveNavbar(routes)}
            fixed={fixed}
            {...rest}
          />
        </Portal>

        {getRoute() && (
          <PanelContent>
            <PanelContainer>
              <Switch>
                {getRoutes(routes)}
                <Redirect from="/merchant" to="/merchant/dashboard" />
              </Switch>
            </PanelContainer>
          </PanelContent>
        )}

        <Portal>
          <FixedPlugin
            secondary={getActiveNavbar(routes)}
            fixed={fixed}
            onOpen={onOpen}
          />
        </Portal>

        <Configurator
          secondary={getActiveNavbar(routes)}
          isOpen={isOpen}
          onClose={onClose}
          isChecked={fixed}
          onSwitch={(value) => setFixed(value)}
          onOpaque={() => setSidebarVariant('opaque')}
          onTransparent={() => setSidebarVariant('transparent')}
        />
      </MainPanel>
    </ChakraProvider>
  );
}